import { useEffect, useState, useMemo } from 'react'
import { useNetworkOptions } from '~/hooks'
import NetworkListBox from '~/components/TokenListModal/components/NetworkListBox'

interface NetworkListProps {
  selectedChainId: number | null
  selectedHistory: number[]
  setSelectedChainId: (chainId: number | null) => void
  setDisplayTokenList: (display: boolean) => void
}

/**
 * 第一层级（当前组件）的网络选中不会改变顺序，进入到第二层级（点击 more 打开的 NetworkConnectOptions）后选中的网络会被推到第一层级的最前面，把用户常用的网络放在第一层级
 */
const NetworkList: React.FC<NetworkListProps> = ({
  selectedChainId,
  selectedHistory,
  setSelectedChainId,
  setDisplayTokenList,
}) => {
  const networks = useNetworkOptions()

  const sortedNetworks = useMemo(() => {
    const result = networks.sort((a, b) => {
      const aIndex = selectedHistory.indexOf(a.chainId)
      const bIndex = selectedHistory.indexOf(b.chainId)

      if (aIndex === -1 && bIndex === -1) return 0
      if (aIndex === -1) return 1
      if (bIndex === -1) return -1
      return aIndex - bIndex
    })
    return result
  }, [networks, selectedHistory])

  const handleSelectNetwork = (chainId: number | null) => {
    setSelectedChainId(chainId)
  }

  const handleDisplayMore = (display: boolean) => {
    setDisplayTokenList(!display)
  }

  return (
    <NetworkListBox
      networks={sortedNetworks}
      selectedChainId={selectedChainId}
      handleSelectNetwork={handleSelectNetwork}
      handleDisplayMore={handleDisplayMore}
    />
  )
}

export default NetworkList
